<template>
  <form @submit.prevent="onSearch" v-if="courseNameDropdown && courseNameDropdown.length">
    <div class="row">
      <div class="col-lg-5 col-md-6 col-sm-12">
          <SelectVue
              v-model="filters.courseId"
              :options="courseNameDropdown"
              :is-clear="true"
              placeholder="Bezeichnung" />
      </div>
      <div class="col-lg-5 col-md-6 col-sm-12">
        <div v-if="officeDropdown && officeDropdown.length">
          <SelectVue
              v-model="filters.officeId"
              :options="officeDropdown"
              :is-clear="true"
              placeholder="Standorte"/>
        </div>
      </div>
      <div class="col-lg-2 col-md-12 col-12 order-last order-lg-0 text-center text-lg-left mb-3 mb-lg-0">
        <SearchButton
            type="submit"
            :label="$t('general.button.search')"
            :loading="loading"/>
      </div>

      <div class="col-lg-5 col-md-6 col-sm-12">
        <div v-if="clientDropdown && clientDropdown.length">
          <SelectVue
              v-model="filters.clientId"
              :options="clientDropdown"
              :is-clear="true"
              :placeholder="$t('placeholder.client_name')"/>
        </div>
      </div>
      <div class="col-lg-3 col-md-6 col-sm-12">
        <div v-if="operationTypeDropdown && operationTypeDropdown.length">
          <SelectVue
              v-model="filters.operationType"
              :options="operationTypeDropdown"
              :is-clear="true"
              placeholder="Maßnahmenart"/>
        </div>
      </div>
      <div class="col-lg-2 col-md-6 col-sm-12">
        <div v-if="courseActionNumberDropdown && courseActionNumberDropdown.length">
          <SelectVue
              v-model="filters.actionNumber"
              :options="courseActionNumberDropdown"
              :is-clear="true"
              placeholder="Maßnahmen-Nr."/>
        </div>
      </div>

    </div>
  </form>
</template>

<script setup>
import SelectVue from '@/components/SelectVue.vue';
import { defineEmits, defineProps, toRefs } from 'vue';
import SearchButton from "@/components/button/SearchButton.vue";

// Define props
const props = defineProps({
  filters: {
    type: Object,
    required: true,
  },
  loading: {
    type: Boolean,
    default: false,
  },
  type: {
    type: String,
    default: '',
  },
  officeDropdown: {
    type: Array,
    required: true,
  },
  clientDropdown: {
    type: Array,
    required: true,
  },
  courseNameDropdown: {
    type: Array,
    required: true,
  },
  courseActionNumberDropdown: {
    type: Array,
    required: true,
  },
  operationTypeDropdown: {
    type: Array,
    required: true,
  },
});

const emit                       = defineEmits([ 'search' ]);
const { filters }                = toRefs(props);
const officeDropdown             = toRefs(props)[ 'officeDropdown' ];
const clientDropdown             = toRefs(props)[ 'clientDropdown' ];
const operationTypeDropdown      = toRefs(props)[ 'operationTypeDropdown' ];
const courseNameDropdown         = toRefs(props)[ 'courseNameDropdown' ];
const courseActionNumberDropdown = toRefs(props)[ 'courseActionNumberDropdown' ];

function onSearch() {
  emit('search', 1, undefined, filters.value);
}
</script>

<style scoped>
</style>
